import { Button } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { URL_PATH } from '../../../../../constants';
import { INameSpaceParam, IQueryPathParam, IServiceDetailsValidationModel } from '../../../../../models';
import { useSelector } from '../../../../../store/AppStore';
import { setIsBackButtonWasPressedOnException } from '../../../../../store/reducer/services/ServiceOperationMonitorReducer';
import { addServiceDetailsToStore } from '../../../../../utilities/services/ServiceDetailsUtils';
import { getModeFromUrl, getVersionFromUrl } from '../../../../../utilities/services/ServiceListUtils';
import classes from './ViewEditServiceDetailsButtons.module.scss';

interface IViewServiceDetailsButtonsProps {
  isEdit: boolean;
  formData: IServiceDetailsValidationModel;
  headerParamList: IQueryPathParam[];
  requestParamList: IQueryPathParam[];
  queryPathParamList: IQueryPathParam[];
  soapNamespaceList: INameSpaceParam[] | undefined;
}

const ViewServiceDetailsButtons = ({
  isEdit,
  formData,
  headerParamList,
  requestParamList,
  queryPathParamList,
  soapNamespaceList,
}: IViewServiceDetailsButtonsProps) => {
  const { t: translate } = useTranslation();
  const { serviceDetails: navBarServiceDetails } = useSelector(
    (state) => state.navBarStateReducer
  );
  const { serviceName, checkClicked } = useSelector(
    (state) => state.serviceDetailsReducer
  );
  const dispatch = useDispatch();
  const history = useNavigate();
  const location = useLocation();

  const nextBtnClickHandler = () => {
    if (isEdit) {
      dispatch(setIsBackButtonWasPressedOnException(false));
      addServiceDetailsToStore(
        formData,
        dispatch,
        checkClicked,
        headerParamList,
        requestParamList,
        queryPathParamList,
        soapNamespaceList
      );
    }
    history(`${URL_PATH.SERVICE_HOME}${URL_PATH.VIEW_EXCEPTION
      }/${serviceName}/${getVersionFromUrl()}/${getModeFromUrl()}`, { state: location.state });
  };

  const onCancelServiceDetails = () => {
    const queryParam = location.state?.path;
    if (queryParam?.path) {
      history(`${URL_PATH.SERVICE_HOME}${queryParam.path}`);
    } else {
      history(`${URL_PATH.SERVICE_HOME}${queryParam}`);
    }
  };

  return !isEdit ? (
    <div className={classes['btn-container']}>
      <Button
        variant="primary"
        className={classes['btn-save']}
        onClick={nextBtnClickHandler}
        disabled={navBarServiceDetails.state !== 0}
        data-testid="view-next-btn"
      >
        {translate('multi_form_modal_component.btn_next')}
      </Button>
    </div>
  ) : (
    <div className={`${classes['btn-container']} ci-button-group`}>
      <Button
        variant="secondary"
        className={classes['btn-back']}
        onClick={onCancelServiceDetails}
        data-testid="service-cancel-btn"
      >
        {translate('multi_form_modal_component.btn_cancel')}
      </Button>
      <Button
        variant="primary"
        onClick={nextBtnClickHandler}
        disabled={navBarServiceDetails.state !== 0}
        data-testid="edit-next-btn"
      >
        {translate('multi_form_modal_component.btn_next')}
      </Button>
    </div>
  );
};

export default ViewServiceDetailsButtons;
